import React from 'react'

const EmptyCalendarIcon = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'>
			<rect width='54' height='49.5' x='9' y='13.5' stroke='currentColor' strokeWidth='1.5' rx='2' />
			<path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='M22.5 13.5V9M49.5 13.5V9' />
			<path stroke='currentColor' strokeLinejoin='round' strokeWidth='1.5' d='M9 27h54' />
			<path
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M18 38.25h4.5M18 49.5h4.5M33.75 38.25h4.5M49.5 38.25H54M33.75 49.5h4.5'
			/>
			<path
				fill='currentColor'
				d='M21.115 50.965c-3.878-3.923-10.228-3.957-14.15-.08-3.923 3.882-3.957 10.229-.08 14.15 3.879 3.923 10.229 3.958 14.15.076 3.923-3.878 3.957-10.228.08-14.15v.004zm-6.599 11.007c-.173.167-.403.252-.689.252-.286 0-.516-.082-.685-.252a.844.844 0 01-.261-.635c0-.258.088-.475.267-.645a.95.95 0 01.682-.254.95.95 0 01.683.255c.176.17.267.383.267.644a.84.84 0 01-.26.635h-.004zm1.818-5.22c-.151.295-.409.622-.78.98l-.475.454c-.296.286-.466.62-.51 1.003l-.022.359h-1.5c0-.548.066-.982.198-1.306.133-.324.378-.644.73-.959.352-.314.588-.57.705-.767.116-.198.176-.406.176-.626 0-.66-.305-.99-.912-.99-.29 0-.523.087-.692.266-.173.18-.264.425-.274.736H11.28c.006-.745.248-1.33.723-1.752.475-.42 1.123-.632 1.94-.632.818 0 1.47.202 1.925.601.457.4.686.966.686 1.695 0 .334-.075.645-.223.94l.003-.002z'
			/>
		</svg>
	)
}

export default EmptyCalendarIcon
